import React, { useState, useContext, useEffect } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import './NewsOption.css';
import { useNavigate } from "react-router-dom";
import URLstateContext from "../../../provider/CommonContext";


function MarketEquity(props) {
    let getOptionNews = props.optionNews;
    const { BaseURL } = useContext(URLstateContext);
    const [optionInfo, setOptionInfo] = useState('');
    let navigate = useNavigate();

    useEffect(() => {
        if (optionInfo === "Corporate News") {
            navigate("/CompanyNews/Corporate-News");
        }
        if (optionInfo === "Economy News") {
            navigate("/CompanyNews/Economy-News");
        }
        if (optionInfo === "End-Session Commentary") {
            navigate("/CompanyNews/End-Session-Commentary");
        }
        if (optionInfo === "Foreign Markets") {
            navigate("/CompanyNews/Foreign-Markets");
        }
        if (optionInfo === "Hot Pursuit") {
            navigate("/CompanyNews/Hot-Pursuit");
        }
        if (optionInfo === "Market Beat") {
            navigate("/CompanyNews/Market-Beat");
        }
        if (optionInfo === "Mid-Session Commentary") {
            navigate("/CompanyNews/Mid-Session-Commentary");
        }
        if (optionInfo === "Other Markets News") {
            navigate("/CompanyNews/Other-Markets-News");
        }
        if (optionInfo === "Pre-Session Commentary") {
            navigate("/CompanyNews/Pre-Session-Commentary");
        }
        if (optionInfo === "Stock Alert") {
            navigate("/CompanyNews/Stock-Alert");
        }
        if (optionInfo === "Futures Market") {
            navigate("/CompanyNews/Futures-Market");
        }
        if (optionInfo === "Overview") {
            navigate("/market/stocks");
        }
        if (optionInfo === "Corporate Results") {
            navigate("/CompanyNews/Corporate-Results");
        }

    }, [optionInfo]);


    return (
        <>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='market-loser-sc'>
                            <div className='market-inner'>
                                <div className='market-select'>
                                    <select id="news" value={getOptionNews} onChange={(event) => { setOptionInfo(event.target.value) }}>
                                        <option value={"Overview"}>Overview</option>
                                        <option value={"Hot Pursuit"}>Hot Pursuit</option>
                                        <option value={"Pre-Session Commentary"}>Pre-Session Commentary</option>
                                        <option value={"Mid-Session Commentary"}>Mid-Session Commentary</option>
                                        <option value={"End-Session Commentary"}>End-Session Commentary</option>
                                        <option value={"Corporate News"}>Corporate News</option>
                                        <option value={"Market Beat"}>Market Beat</option>
                                        <option value={"Economy News"}>Economy News</option>
                                        <option value={"Other Markets News"}>Other Markets News</option>
                                        <option value={"Corporate Results"}>Corporate Results</option>
                                        <option value={"Stock Alert"}>Stock Alert</option>
                                        <option value={"Futures Market"}>Futures Market</option>
                                        <option value={"Foreign Markets"}>Foreign Markets</option>
                                    </select>
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default MarketEquity;